import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import DatePicker from 'components/DatePicker/DatePicker';
import { PROFIT_CENTER_LINKS } from 'constants/formFields';
import { DATE_FORMAT } from 'constants/general';

import type { TDate } from 'components/DatePicker/interfaces/TDate';
import type { FieldPath } from 'react-hook-form';
import type { TCreateSupplierSchema } from 'utils/validators';
import type IDateSectionProps from '../interfaces/IDateSectionProps';

import styles from '../sass/ProfitCenterLinks.module.scss';

function DateSection({
  control,
  index,
  startDate,
  onStartDateChange,
  onEndDateChange,
}: IDateSectionProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.formRow}>
      <Controller
        control={control}
        name={`${PROFIT_CENTER_LINKS}.${index}.startDate` as FieldPath<TCreateSupplierSchema>}
        render={({ field: { name, value, onChange }, fieldState: { error } }) => (
          <DatePicker
            name={name}
            label={t('suppliers.fields.startDate')}
            error={error?.message}
            onChange={(date: TDate) => {
              onChange(date);
              onStartDateChange(date);
            }}
            value={value}
            placeholder={DATE_FORMAT}
            required
            maxDate={new Date()}
          />
        )}
      />

      <Controller
        control={control}
        name={`${PROFIT_CENTER_LINKS}.${index}.endDate` as FieldPath<TCreateSupplierSchema>}
        render={({ field: { name, value, onChange }, fieldState: { error } }) => (
          <DatePicker
            name={name}
            label={t('suppliers.fields.endDate')}
            error={error?.message}
            onChange={(date: TDate) => {
              onChange(date);
              onEndDateChange(date);
            }}
            value={value}
            minDate={startDate ? new Date(startDate) : undefined}
            placeholder={DATE_FORMAT}
            required
          />
        )}
      />
    </div>
  );
}

export default DateSection;
